import { Plug, ToggleLeft } from 'lucide-react';
import { HubPageLayout, SettingsRowDef } from './HubPageLayout';

export function PlatformHubPage() {
  const rows: SettingsRowDef[] = [
    {
      id: 'features',
      label: 'Features',
      desc: 'Enable or disable platform capabilities.',
      icon: ToggleLeft,
      path: '/admin/platform/features',
    },
    {
      id: 'integrations',
      label: 'Integrations',
      desc: 'SmartMoving and third-party connections.',
      icon: Plug,
      path: '/admin/platform/integrations',
    },
  ];

  return (
    <HubPageLayout
      title="Platform"
      subtitle="Feature toggles and integrations."
      rows={rows}
    />
  );
}
